const mapViewEmits = {
    markerClick: (_markerID) => true,
    mapLoading: (_loading) => true,
    setBounds: (_bounds) => true,
    zoomEnd: () => true,
};

export { mapViewEmits };
